module.exports = __webpack_public_path__ + "img/apply-main-img.206ad570.png";